module.exports = __webpack_public_path__ + "img/user.2a13cad5.png";